const MS_PER_DAY = 1000 * 60 * 60 * 24;
const EXPIRING_SOON_DAYS = 30;

export const CUSTOMER_REPORT_STATUS = {
	EXPIRED: 'expired',
	EXPIRING_SOON: 'expiringSoon',
	ACTIVE: 'active',
};

const CUSTOMER_REPORT_STATUS_META = {
	[CUSTOMER_REPORT_STATUS.EXPIRED]: {
		key: CUSTOMER_REPORT_STATUS.EXPIRED,
		labelKey: 'reports.labels.expired',
		fallbackLabel: 'Expired',
		rowClassName: 'expired',
		legendClassName: 'is-expired',
	},
	[CUSTOMER_REPORT_STATUS.EXPIRING_SOON]: {
		key: CUSTOMER_REPORT_STATUS.EXPIRING_SOON,
		labelKey: 'reports.labels.expiring_soon',
		fallbackLabel: 'Expiring Soon',
		rowClassName: 'lessThanWeek',
		legendClassName: 'is-expiring-soon',
	},
	[CUSTOMER_REPORT_STATUS.ACTIVE]: {
		key: CUSTOMER_REPORT_STATUS.ACTIVE,
		labelKey: 'reports.labels.active',
		fallbackLabel: 'Active',
		rowClassName: 'moreThanThirtyDays',
		legendClassName: 'is-active',
	},
};

const getDaysUntilDate = (inputDate) => {
	if (!inputDate) {
		return null;
	}

	const targetDate = new Date(inputDate);
	if (Number.isNaN(targetDate.getTime())) {
		return null;
	}

	const today = new Date();
	today.setHours(0, 0, 0, 0);
	targetDate.setHours(0, 0, 0, 0);

	return Math.ceil((targetDate - today) / MS_PER_DAY);
};

export const getCustomerReportStatusKey = (nextBillDate) => {
	const daysUntilNextBill = getDaysUntilDate(nextBillDate);

	if (daysUntilNextBill === null) {
		return CUSTOMER_REPORT_STATUS.ACTIVE;
	}

	if (daysUntilNextBill <= 0) {
		return CUSTOMER_REPORT_STATUS.EXPIRED;
	}

	if (daysUntilNextBill <= EXPIRING_SOON_DAYS) {
		return CUSTOMER_REPORT_STATUS.EXPIRING_SOON;
	}

	return CUSTOMER_REPORT_STATUS.ACTIVE;
};

export const getCustomerReportStatusMeta = (nextBillDate) => CUSTOMER_REPORT_STATUS_META[getCustomerReportStatusKey(nextBillDate)];

export const getCustomerReportRowClassName = (nextBillDate) => getCustomerReportStatusMeta(nextBillDate).rowClassName;

export const getCustomerReportLegendItems = (t) => [
	CUSTOMER_REPORT_STATUS.EXPIRED,
	CUSTOMER_REPORT_STATUS.EXPIRING_SOON,
	CUSTOMER_REPORT_STATUS.ACTIVE,
].map((statusKey) => {
	const statusMeta = CUSTOMER_REPORT_STATUS_META[statusKey];

	return {
		key: statusMeta.key,
		label: t(statusMeta.labelKey) || statusMeta.fallbackLabel,
		legendClassName: statusMeta.legendClassName,
		rowClassName: statusMeta.rowClassName,
	};
});